// Theme.js
'use strict';

//import "@babel/polyfill/dist/polyfill.min";
//import "@babel/polyfill/noConflict";

// Not use import because replace "$" and fancybox is not OK.
//var $ = require('jquery/dist/jquery.min');

import bsBreakpoints from "bs-breakpoints/dist/bs-breakpoints.min";
import Mustache from "mustache/mustache.min";
import JsCookies from "js-cookie";

//require('@fancyapps/fancybox/dist/jquery.fancybox.min');
import "@fancyapps/fancybox/dist/jquery.fancybox.min";

// bootstrap.bundle.min.js has popper.min.js, bootstrap.min.js not.
import "bootstrap/dist/js/bootstrap.bundle.min";

import * as $ from "jquery";
// create global $ and jQuery variables
global.$ = global.jQuery = $;

/**
 * Theme Class
 */
export default class CmbmDefaultTheme {
	/**
	 * Init theme.
	 */
	static init() {
		this.initWpAdmin();
		this.initTooltip();
		this.initModal();
		this.initTargetLinks();
		this.initHovers();
		this.initResponsiveBgImages();
		this.initNavigation();
		this.initTextareaLimit();
		this.initMap();
		this.initGalleryPhotos();
		this.initAnimations();
		this.initVideo();
		this.initSocial();
		//this.initGdpr();
	}

	static initWpAdmin() {
		var wpadminbar = $("#wpadminbar");
		if (wpadminbar.length > 0) {
			$("body").addClass('wpadminbar');
		}
	}

	static initTooltip() {
		$('[data-toggle="tooltip"]').tooltip();
	}

	static setResponsiveBgImages() {
		$(".responsive-bg-image").each(function (index, element) {
			var currentBreakpoint = bsBreakpoints.getCurrentBreakpoint();
			var attributTarget = 'data-bg-image-xl';

			switch (currentBreakpoint) {
				case 'xSmall': // min:0,max:575
					attributTarget = 'data-bg-image-xs';
					break;
				case 'small': // min:576,max:767
					attributTarget = 'data-bg-image-sm';
					break;
				case 'medium': // min:768,max:991
					attributTarget = 'data-bg-image-md';
					break;
				case 'large': // min:992,max:1199
					attributTarget = 'data-bg-image-lg';
					break;
				case 'xLarge': // min:1200,max:1/0
					attributTarget = 'data-bg-image-xl';
					break;
			}

			var bgImageUrl = $(this).attr(attributTarget);
			if (typeof bgImageUrl !== 'undefined') {
				$(this).attr('style', 'background-image: url(\'' + bgImageUrl + '\')');
			}
		});
	}

	static initModal() {
		$(".modal-page-content").each(function (index, element) {
			$('body').append($(element));
		});

		$('[data-fancybox]').fancybox({
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: "Fermer",
					NEXT: "Suivant",
					PREV: "Précédent",
					ERROR: "Le contenu demandé ne peut pas être chargé. <br/><br/><strong>Veuillez réessayer plus tard</strong>.",
					PLAY_START: "Démarrer le diaporama",
					PLAY_STOP: "Pause du diaporama",
					FULL_SCREEN: "Plein écran",
					THUMBS: "Videos",
					DOWNLOAD: "Télécharger",
					SHARE: "Partager",
					ZOOM: "Zoom"
				}
			},
		});
	}

	static initTargetLinks() {
		$('[data-targetlink]').click(function (event) {
			if (typeof $(this).data('src') !== 'undefined') {
				window.open($(this).data('src'), '_blank');

				return false;
			}
		});
	}

	static initHovers() {
		/*
		$(".block-gallery-item > figure > a").hover(
			function(){
				$(".caption-hover").hide();
				$(this).find(".caption-hover").fadeIn(500);
			},

			function () {
				$(this).find(".caption-hover").hide();
			}
		);
		 */
	}

	static initResponsiveBgImages() {
		this.setResponsiveBgImages();

		$(window).on('init.bs.breakpoint', function (e) {
			// on init
			CmbmDefaultTheme.setResponsiveBgImages();
		});

		$(window).on('new.bs.breakpoint', function (e) {
			// on change
			CmbmDefaultTheme.setResponsiveBgImages();
		});
	}

	static getCurrentGAId() {
		var analyticsId = $("#analytics[data-ga-id]");
		if (analyticsId.length > 0) {
			return analyticsId.attr('data-ga-id');
		}

		return '';
	}

	static getPagePrivacyPolicy() {
		var gdprPage = $("#gdpr[data-url-page-for-privacy-policy]");
		if (gdprPage.length > 0) {
			return gdprPage.attr('data-url-page-for-privacy-policy');
		}

		return '';
	}

	static cleanupCookies() {
		var currentDomain = window.location.hostname.replace(/(www|preprod)/i, '');

		JsCookies.remove('buildeo_gdpr_compliance');

		// Delete GA cookies
		JsCookies.remove('_ga', {
			domain: currentDomain
		});
		JsCookies.remove('_gat', {
			domain: currentDomain
		});
		JsCookies.remove('_gid', {
			domain: currentDomain
		});

		var currentGAId = CmbmDefaultTheme.getCurrentGAId();
		if (currentGAId.length > 0) {
			JsCookies.remove('_gat_gtag_' + currentGAId.replace(/-/g, '_'), {
				domain: currentDomain
			});
		}
	}

	static enableGA() {
		// enable cookies Google Analytics ?
		//var cookieGdpr = JsCookies.getJSON('buildeo_gdpr_compliance');
		var gdprComplianceCookie = JsCookies.get('buildeo_gdpr_compliance')
		if (typeof gdprComplianceCookie !== 'undefined') {
			var cookieGdpr = JSON.parse(gdprComplianceCookie);

			var currentGAId = CmbmDefaultTheme.getCurrentGAId();
			if (currentGAId.length > 0 && typeof cookieGdpr !== 'undefined' &&
				((typeof cookieGdpr['all-cookies-accepted'] !== 'undefined' && cookieGdpr['all-cookies-accepted'] === 'yes') || (typeof cookieGdpr['custom-cookies-stats-accepted'] !== 'undefined' && cookieGdpr['custom-cookies-stats-accepted'] === 'yes'))
			) {
				window.dataLayer = window.dataLayer || [];

				function gtag() {
					dataLayer.push(arguments);
				}

				gtag('js', new Date());

				var t1 = new Date(cookieGdpr['dateConsent']);
				var t2 = new Date();
				var expiresTime = Math.abs(31536000 - ((t2.getTime() - t1.getTime()) / 1000));

				if (expiresTime < 0) {
					expiresTime = 0;
				}

				gtag('config', currentGAId, {
					'anonymize_ip': true,
					'cookie_expires': expiresTime
				});
			}
		}
	}

	static initGdprContent(modalId) {
		var containerGdpr = $('#gdpr');
		if (containerGdpr.length) {
			var template = $("#gdpr-template").html();
			var html_template = Mustache.render(template, {});

			$(html_template).appendTo(containerGdpr);
		}
	}

	static customSaveGdpr(modalId) {
		//$("#btn-gdpr-cookies-custom-save").off('click').on('click', function (event) {
		$("#btn-gdpr-cookies-custom-save").click(function (event) {
			// event.preventDefault();

			var gdprData = {
				"custom-cookies-stats-accepted": "no",
				"custom-cookies-share-accepted": "no",
				"dateConsent": new Date()
			};

			var customOptionStats = $('#' + modalId + '-option-stats');
			if (typeof customOptionStats !== 'undefined' && customOptionStats.is(':checked')) {
				gdprData["custom-cookies-stats-accepted"] = 'yes';
			}

			var customOptionShare = $('#' + modalId + '-option-share');
			if (typeof customOptionShare !== 'undefined' && customOptionShare.is(':checked')) {
				gdprData["custom-cookies-share-accepted"] = 'yes';
			}

			JsCookies.set('buildeo_gdpr_compliance', JSON.stringify(gdprData), {
				expires: 365
			});

			$("#gdpr-cookies-notice").hide();
			$(".messages.global").hide();
			if (typeof $('#' + modalId) !== 'undefined') {
				$('#' + modalId).modal('hide');
			} else {
				$(".modal-backdrop").hide();
			}

			$("body").css({
				'margin-bottom': '0'
			});

			CmbmDefaultTheme.enableGA();
		});
	}

	static initGdpr() {
		var modalId = 'gdprModalCookiesCustom';

		CmbmDefaultTheme.initGdprContent(modalId);
		CmbmDefaultTheme.customSaveGdpr(modalId);

		var useCookieGdpr = $("#gdpr-cookies-notice");
		if (typeof useCookieGdpr !== 'undefined') {
			$("#btn-view-banner-cookies").click(function (event) {
				$("#gdpr-cookies-notice").show();
				$(".messages.global").show();

				$("body").css({
					'margin-bottom': '80px'
				});
			});

			$("#btn-gdpr-cookies-all-allow").click(function (event) {
				var gdprData = {
					"all-cookies-accepted": "yes",
					"dateConsent": new Date()
				};
				JsCookies.set('buildeo_gdpr_compliance', JSON.stringify(gdprData), {
					expires: 365
				});
				$(".messages.global").hide();
				useCookieGdpr.hide();
				$("body").css({
					'margin-bottom': '0'
				});

				CmbmDefaultTheme.enableGA();
			});

			$("#btn-gdpr-cookies-only-technical-allow").click(function (event) {
				var gdprData = {
					"custom-cookies-stats-accepted": "no",
					"custom-cookies-share-accepted": "no",
					"dateConsent": new Date()
				};
				JsCookies.set('buildeo_gdpr_compliance', JSON.stringify(gdprData), {
					expires: 365
				});
				$(".messages.global").hide();
				useCookieGdpr.hide();
				$("body").css({
					'margin-bottom': '0'
				});
			});

			let hasCookieGdprCompliance = false;
			var gdprComplianceCookie = JsCookies.get('buildeo_gdpr_compliance')
			if (typeof gdprComplianceCookie !== 'undefined') {
				var cookieGdpr = JSON.parse(gdprComplianceCookie);

				if (typeof cookieGdpr === 'undefined') {
					hasCookieGdprCompliance = false;
				} else {
					hasCookieGdprCompliance = true;
				}
			}

			if(!hasCookieGdprCompliance) {
				CmbmDefaultTheme.cleanupCookies();

				var customOptionStats = $('#' + modalId + '-option-stats');
				if (typeof customOptionStats !== 'undefined') {
					if (customOptionStats.is(':checked')) {
						customOptionStats.parents('.card').addClass('card-success');
					} else {
						customOptionStats.parents('.card').removeClass('card-success');
					}

					customOptionStats.click(function (event) {
						if (customOptionStats.is(':checked')) {
							customOptionStats.parents('.card').addClass('card-success');
						} else {
							customOptionStats.parents('.card').removeClass('card-success');
						}
					});
				}

				var customOptionShare = $('#' + modalId + '-option-share');
				if (typeof customOptionShare !== 'undefined') {
					if (customOptionShare.is(':checked')) {
						customOptionShare.parents('.card').addClass('card-success');
					} else {
						customOptionShare.parents('.card').removeClass('card-success');
					}

					customOptionShare.click(function (event) {
						if (customOptionShare.is(':checked')) {
							customOptionShare.parents('.card').addClass('card-success');
						} else {
							customOptionShare.parents('.card').removeClass('card-success');
						}
					});
				}

				$("body").css({
					'margin-bottom': '80px'
				});
				$("#gdpr-cookies-notice").show();
				$(".messages.global").show();
			} else {
				$(".messages.global").hide();
				$("#gdpr-cookies-notice").hide();
				$("body").css({
					'margin-bottom': '0'
				});

				CmbmDefaultTheme.enableGA();
			}

			$("#btn-gdpr-reset-cookies").click(function (event) {
				if(typeof $.fancybox === 'object'
					&& typeof parent.jQuery !== 'undefined'
					&& typeof parent.jQuery.fancybox !== 'undefined'
					&& typeof parent.jQuery.fancybox.getInstance() !== 'undefined'
					&& parent.jQuery.fancybox.getInstance() !== false) {
					parent.jQuery.fancybox.getInstance().close();
				}

				CmbmDefaultTheme.cleanupCookies();

				$("body").css({
					'margin-bottom': '80px'
				});
				$("#gdpr-cookies-notice").show();
				$(".messages.global").show();
			});

			const gdprModal = document.getElementById(modalId);
			if(gdprModal) {
				gdprModal.addEventListener('show.bs.modal', event => {
					let hasCookieGdprCompliance = false;
					var gdprComplianceCookie = JsCookies.get('buildeo_gdpr_compliance')
					if (typeof gdprComplianceCookie !== 'undefined') {
						var cookieGdpr = JSON.parse(gdprComplianceCookie);

						if (typeof cookieGdpr === 'undefined') {
							hasCookieGdprCompliance = false;
						} else {
							hasCookieGdprCompliance = true;
						}

						if (hasCookieGdprCompliance) {
							var customOptionStats = $('#' + modalId + '-option-stats');
							if (typeof customOptionStats !== 'undefined') {
								if ((typeof cookieGdpr['all-cookies-accepted'] !== 'undefined' && cookieGdpr['all-cookies-accepted'] === 'yes' && !customOptionStats.is(':checked')) || (typeof cookieGdpr['custom-cookies-stats-accepted'] !== 'undefined' && cookieGdpr['custom-cookies-stats-accepted'] === 'yes' && !customOptionStats.is(':checked'))) {
									customOptionStats.prop('checked', true);
								}

								if ((typeof cookieGdpr['all-cookies-accepted'] !== 'undefined' && cookieGdpr['all-cookies-accepted'] === 'no' && customOptionStats.is(':checked')) || (typeof cookieGdpr['custom-cookies-stats-accepted'] !== 'undefined' && cookieGdpr['custom-cookies-stats-accepted'] === 'no' && customOptionStats.is(':checked'))) {
									customOptionStats.prop('checked', false);
								}
							}
						}
					}
				});
			}
		}
	}

	static initNavigation() {
		var currentBreakpoint = bsBreakpoints.getCurrentBreakpoint();

		$('body')
			.on('mouseenter mouseleave', '.dropdown', function(e) {
				//toggleDropdown()
			})
			.on('click', '.dropdown > a', function(e) {
				window.location = $(this).attr('href');
				//toggleDropdown()
			});

		let clickEventType = ((document.ontouchstart!==null)?'click':'touchstart');
		//console.log('clickEventType ? = ' + clickEventType);
		if(clickEventType === 'touchstart') {
			$('body').on(clickEventType, '.container-navigation-bar > .dropdown > .dropdown-toggle', function(e) {
				//console.log('dropdown-toggle show ? = ' + $(this).hasClass('show'));

				/*
				if(!$(this).hasClass('show')) {
					$('.container-navigation-bar > .dropdown > .dropdown-toggle').addClass('show');
					$('.container-navigation-bar > .dropdown > .dropdown-menu').addClass('show');
				} else {
					$('.container-navigation-bar > .dropdown > .dropdown-toggle').removeClass('show');
					$('.container-navigation-bar > .dropdown > .dropdown-menu').removeClass('show');
				}
				 */
			});
		} else {
			$('.dropdown').hover(function () {
				$(this).find('.dropdown-toggle').addClass('show');
				$(this).find('.dropdown-menu').addClass('show');
			}, function () {
				$(this).find('.dropdown-toggle').removeClass('show');
				$(this).find('.dropdown-menu').removeClass('show');
			});
		}
	}

	static initMap() {

	}

	static initGalleryPhotos() {
		$('[data-fancybox="gallery"]').fancybox({
			caption : function( instance, item ) {
				var caption = $(this).data('caption') || '';
				var description = $(this).data('description') || '';
				var credits = $(this).data('credits') || '';

				if (caption.length) {
					caption = '<span class="title">' + caption + '</span><br />';
				}

				if (description.length) {
					caption += '<span class="description"> ' + description + '</span><br />';
				}

				if (credits.length) {
					caption += '<span class="credits"> ' + credits + '</span>';
				}

				return caption;
			},
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: "Fermer",
					NEXT: "Suivant",
					PREV: "Précédent",
					ERROR: "Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.",
					PLAY_START: "Démarrer le diaporama",
					PLAY_STOP: "Pause du diaporama",
					FULL_SCREEN: "Plein écran",
					THUMBS: "Vignettes",
					DOWNLOAD: "Télécharger",
					SHARE: "Partager",
					ZOOM: "Zoom"
				}
			},
			thumbs : {
				autoStart : false
			}
		});
	}

	static initAnimations() {

	}

	static initVideo() {
		$('a.video,p.video a,.wp-block-button.video>a').fancybox({
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: "Fermer",
					NEXT: "Suivant",
					PREV: "Précédent",
					ERROR: "Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.",
					PLAY_START: "Démarrer le diaporama",
					PLAY_STOP: "Pause du diaporama",
					FULL_SCREEN: "Plein écran",
					THUMBS: "Vignettes",
					DOWNLOAD: "Télécharger",
					SHARE: "Partager",
					ZOOM: "Zoom"
				}
			},
		});
	}

	static initSocial() {
		$('.fb-share').click(function(e) {
			e.preventDefault();
			window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

			return false;
		});
	}

	/**
	 * Init limit chars on textarea fields.
	 */
	static initTextareaLimit() {
		// eslint-disable-next-line
		$('.textarea1000').keyup(function () {
			const maxChars = 1000;
			// eslint-disable-next-line
			const text = $(this).val();

			if (text.length > maxChars) {
				// eslint-disable-next-line
				$(this).val(text.substr(0, maxChars));
			}

			// eslint-disable-next-line
			$(this).closest('.form-group').find('.msglimitchars > span').html((maxChars - $(this).val().length));
		});

		// Use to check on first load page without key pressed
		$('.textarea1000').keyup();
	}
}

$(document).ready(() => {
	let btnBackToTop = $('#back-to-top');
	$(window).scroll(function () {
		if ($(window).scrollTop() > 100) {
			btnBackToTop.removeClass('hidden');
		} else {
			btnBackToTop.addClass('hidden');
		}
	});

	btnBackToTop.on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({scrollTop: 0}, '300');
	});

	bsBreakpoints.init();
	CmbmDefaultTheme.init();
});
